// Bundled syntax highlighting (highlight.js core + a curated language set) plus
// a code-block header with the language label and a copy button.
// No CDN: languages are compiled into the theme bundle by Rollup.

import hljs from "highlight.js/lib/core";

import javascript from "highlight.js/lib/languages/javascript";
import typescript from "highlight.js/lib/languages/typescript";
import python from "highlight.js/lib/languages/python";
import rust from "highlight.js/lib/languages/rust";
import go from "highlight.js/lib/languages/go";
import sql from "highlight.js/lib/languages/sql";
import bash from "highlight.js/lib/languages/bash";
import yaml from "highlight.js/lib/languages/yaml";
import json from "highlight.js/lib/languages/json";
import css from "highlight.js/lib/languages/css";
import xml from "highlight.js/lib/languages/xml";
import markdown from "highlight.js/lib/languages/markdown";
import diff from "highlight.js/lib/languages/diff";
import plaintext from "highlight.js/lib/languages/plaintext";

hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("typescript", typescript);
hljs.registerLanguage("python", python);
hljs.registerLanguage("rust", rust);
hljs.registerLanguage("go", go);
hljs.registerLanguage("sql", sql);
hljs.registerLanguage("bash", bash);
hljs.registerLanguage("yaml", yaml);
hljs.registerLanguage("json", json);
hljs.registerLanguage("css", css);
hljs.registerLanguage("xml", xml);
hljs.registerLanguage("markdown", markdown);
hljs.registerLanguage("diff", diff);
hljs.registerLanguage("plaintext", plaintext);

// Map the language names authors commonly type in Ghost code cards.
hljs.registerAliases(["js", "jsx", "mjs", "cjs"], { languageName: "javascript" });
hljs.registerAliases(["ts", "tsx"], { languageName: "typescript" });
hljs.registerAliases(["py"], { languageName: "python" });
hljs.registerAliases(["rs"], { languageName: "rust" });
hljs.registerAliases(["golang"], { languageName: "go" });
hljs.registerAliases(["sh", "shell", "zsh", "console"], { languageName: "bash" });
hljs.registerAliases(["yml"], { languageName: "yaml" });
hljs.registerAliases(["html", "xhtml", "svg"], { languageName: "xml" });
hljs.registerAliases(["md"], { languageName: "markdown" });
hljs.registerAliases(["text", "txt"], { languageName: "plaintext" });

hljs.configure({ ignoreUnescapedHTML: true });

// Pretty display names for the header label.
const LABELS = {
    javascript: "JavaScript", js: "JavaScript", jsx: "JSX", mjs: "JavaScript", cjs: "JavaScript",
    typescript: "TypeScript", ts: "TypeScript", tsx: "TSX",
    python: "Python", py: "Python",
    rust: "Rust", rs: "Rust",
    go: "Go", golang: "Go",
    sql: "SQL",
    bash: "Bash", sh: "Shell", shell: "Shell", zsh: "Shell", console: "Shell",
    yaml: "YAML", yml: "YAML",
    json: "JSON",
    css: "CSS",
    xml: "XML", html: "HTML", markup: "HTML", svg: "SVG",
    markdown: "Markdown", md: "Markdown",
    diff: "Diff",
    plaintext: "Text", text: "Text", txt: "Text",
};

function labelFor(lang) {
    return LABELS[lang] || lang.charAt(0).toUpperCase() + lang.slice(1);
}

function enhanceBlocks() {
    document.querySelectorAll(".gh-content pre").forEach((pre) => {
        if (pre.parentNode.classList.contains("code-block")) return;
        const code = pre.querySelector("code");
        if (!code) return;

        const match = code.className.match(/language-([\w-]+)/);
        const lang = match ? match[1] : "";

        const wrap = document.createElement("div");
        wrap.className = "code-block";

        const bar = document.createElement("div");
        bar.className = "code-block-bar";
        bar.innerHTML =
            '<span class="code-block-dots" aria-hidden="true"><i></i><i></i><i></i></span>' +
            '<span class="code-block-lang">' + (lang ? labelFor(lang) : "") + "</span>" +
            '<button class="code-block-copy" type="button" aria-label="Copy code">Copy</button>';

        pre.parentNode.insertBefore(wrap, pre);
        wrap.appendChild(bar);
        wrap.appendChild(pre);

        const btn = bar.querySelector(".code-block-copy");
        btn.addEventListener("click", async () => {
            try {
                await navigator.clipboard.writeText(code.innerText.replace(/\n$/, ""));
                btn.textContent = "Copied";
                btn.classList.add("is-copied");
                setTimeout(() => {
                    btn.textContent = "Copy";
                    btn.classList.remove("is-copied");
                }, 1600);
            } catch (err) {
                /* clipboard unavailable (e.g. insecure context) */
            }
        });
    });
}

export default function highlightCode() {
    document.querySelectorAll("pre code[class*='language-']").forEach((el) => {
        hljs.highlightElement(el);
    });
    enhanceBlocks();
}
